import _slicedToArray from "C:/Office/_LIVE/AgyagosLanyBFBASE/vue/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:/Office/_LIVE/AgyagosLanyBFBASE/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Helpers
import { mapState } from 'vuex';
import VueSlider from "vue-slider-component";
export default {
  name: 'RangeSlider',
  components: {
    VueSlider: VueSlider
  },
  props: {
    filter: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filterState: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isPrice: {
      type: Boolean,
      default: false
    },
    withIntervals: {
      type: Boolean,
      default: false
    },
    show: Boolean
  },
  data: function data() {
    return {
      value: [0, 1]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['currency'])), {}, {
    slider: function slider() {
      var filter = this.filter,
          withIntervals = this.withIntervals;

      var _filter$options = _slicedToArray(filter.options, 2),
          min = _filter$options[0],
          max = _filter$options[1];

      var minValue = min.value;
      var maxValue = max.value;
      var interval = Math.ceil((maxValue - minValue || 1) / 10);

      if (withIntervals) {
        if (interval > 1000) {
          interval = 1000;
        } else if (interval > 100) {
          interval = 100;
        } else if (interval > 10) {
          interval = 10;
        } else {
          interval = 1;
        }

        if (maxValue % interval > 0) {
          maxValue = interval + maxValue - maxValue % interval;
        }

        if (minValue % interval > 0) {
          minValue = minValue - minValue % interval;
        }

        while ((maxValue - minValue) / interval % 1 > 0) {
          maxValue++;
        }
      }

      return {
        minValue: minValue,
        maxValue: maxValue,
        interval: interval
      };
    }
  }),
  watch: {
    filterState: 'setValue',
    show: function show(state) {
      var _this = this;

      if (state) {
        this.$nextTick(function () {
          setTimeout(function () {
            var _this$$refs$slider;

            (_this$$refs$slider = _this.$refs.slider) === null || _this$$refs$slider === void 0 ? void 0 : _this$$refs$slider.refresh();
          }, 750);
        });
      }
    }
  },
  created: function created() {
    this.setValue();
  },
  methods: {
    formatTooltip: function formatTooltip(value) {
      var isPrice = this.isPrice,
          currency = this.currency,
          formatMoney = this.formatMoney;

      if (isPrice) {
        var _this$$swell$currency = this.$swell.currency.get(currency),
            rate = _this$$swell$currency.rate;

        var price = rate ? value * rate : value;
        return formatMoney(price, currency);
      }

      return value;
    },
    setValue: function setValue() {
      var _this$filter$options = _slicedToArray(this.filter.options, 2),
          min = _this$filter$options[0],
          max = _this$filter$options[1];

      var stateValue = this.filterState[this.filter.id]; // Use the state value if it exists, otherwise the filter's min/max

      this.value = stateValue || [min.value, max.value];
    },
    updateValue: function updateValue(value) {
      var filter = this.filter;

      var _filter$options2 = _slicedToArray(filter.options, 2),
          min = _filter$options2[0],
          max = _filter$options2[1];

      var optionValue; // If the value isn't the same as the filter's min/max, pass it on

      if (value[0] !== min.value || value[1] !== max.value) {
        optionValue = value;
      } // Otherwise, don't pass anything so the filter gets removed


      this.$emit('change', {
        filter: filter,
        optionValue: optionValue
      });
    }
  }
};